<template>

    <div class="BrandResultBlock text-left">
        <h3 class="uppercase mb-4 text-[1.375rem] tooltip-trigger">
            {{ title }}
            <div class="tooltip-card" v-if="isShowTooltip">
                <div class="tooltip-image">
                    <img :src="image" alt="Content preview" />
                </div>
                <div class="tooltip-stats">
                    <div class="stat-item">
                        <span class="heart-icon"><img src="/img/icons/icon_heart.svg" alt="likes"/></span>
                        <span class="stat-text"> {{ formatNumber(insight.likes) }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="comment-icon"><img src="/img/icons/icon_comment.svg" /></span>
                        <span class="stat-text"> {{ formatNumber(insight.comments) }}</span>
                    </div>
                </div>
                <div class="tooltip-views">
                    <div class="flex justify-between tooltip-views-content">
                        <p>Visminger</p>
                        <p>{{ formatNumber(insight.views) }}</p>
                    </div>
                    <div class="flex justify-between tooltip-views-content">
                        <p>Unikke viun</p>
                        <p>{{ formatNumber(insight.reach) }}</p>
                    </div>
                </div>
            </div>
        </h3>
        <div class="BrandResultInfo" v-if="isInfoDetail" style="--column: 7">
            <div>
                <h5>Followers</h5>
                <p>{{ formatNumber(getTotalInfluencerFollowers()) }}</p>
            </div>
            <div>
                <h5>Impressions</h5>
                <p>{{ formatNumber(insight.views) }}</p>
            </div>
            <div>
                <h5>Reach</h5>
                <p>{{ formatNumber(insight.reach) }}</p>
            </div>
            <div>
                <h5>Like</h5>
                <p>{{ formatNumber(insight.likes) }}</p>
            </div>
            <div>
                <h5>Kommentarer</h5>
                <p>{{ formatNumber(insight.comments) }}</p>
            </div>
            <div>
                <h5>Estimeret engagement rate</h5>
                <p>{{ formatPercentage(getEngagementRateInfluencer()) }}</p>
            </div>
            <div>
                <h5>Antal indhold</h5>
                <p>{{ formatNumber(getInfluencerContentMedia()) }}</p>
            </div>
        </div>
        <div class="BrandResultInfo" v-if="isShowPost" style="--column: 5">
            <div>
                <h5>Impressions</h5>
                <p>{{ formatNumber(insight.views) }}</p>
            </div>
            <div>
                <h5>Reach</h5>
                <p>{{ formatNumber(insight.reach) }}</p>
            </div>
            <div>
                <h5>Like</h5>
                <p>{{ formatNumber(insight.likes) }}</p>
            </div>
            <div>
                <h5>Kommentarer</h5>
                <p>{{ formatNumber(insight.comments) }}</p>
            </div>
            <div>
                <h5>Estimeret engagement rate</h5>
                <p>{{ formatPercentage(getEngagementRatePost()) }}</p>
            </div>
        </div>
        <div class="BrandResultInfo" v-if="isShowAll" style="--column: 8">
            <div>
                <h5>Antal influencers</h5>
                <p>{{ formatNumber(getTotalInfluencers()) }}</p>
            </div>
            <div>
                <h5>Followers</h5>
                <p>{{ formatNumber(getTotalCampaignFollowers()) }}</p>
            </div>
            <div>
                <h5>Impressions</h5>
                <p>{{ formatNumber(insight.views) }}</p>
            </div>
            <div>
                <h5>Reach</h5>
                <p>{{ formatNumber(insight.reach) }}</p>
            </div>
            <div>
                <h5>Like</h5>
                <p>{{ formatNumber(insight.likes) }}</p>
            </div>
            <div>
                <h5>Kommentarer</h5>
                <p>{{ formatNumber(insight.comments) }}</p>
            </div>
            <div>
                <h5>Estimeret engagement rate</h5>
                <p>{{ formatPercentage(getEngagementRateCampaign()) }}</p>
            </div>
            <div>
                <h5>Antal indhold</h5>
                <p>{{ formatNumber(getTotalContentMedia()) }}</p>
            </div>
        </div>
    </div>
</template>

<style type="text/less" lang="less">
.BrandResultInfo {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(var(--column), 1fr);
    justify-content: space-between;
    font-family: "Roboto Slab", 'HvDTrial Roboto Light', serif;
    p {
        color: #1825D8 !important;
        font-weight: 400 !important;
    }
}
.BrandResultBlock * {
    font-style: normal;
    color: #000000;
    font-weight: 700;
}
.BrandResultBlock {
    border-bottom: 2px solid #707070;
    padding: 48px 0;

    h3 {
        font-family: "Brandon Grotesque", 'HvDTrial Brandon Grotesque', serif;
        font-weight: 500 !important;
    }
}
@media (max-width: 767px) {
    .BrandResultInfo {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
}

// Add tooltip styles
.tooltip {
    display: block !important;
    z-index: 10000;
    font-family: "Brandon Grotesque", 'HvDTrial Brandon Grotesque', serif;

    .tooltip-inner {
        background: #1825D8;
        color: white;
        border-radius: 4px;
        padding: 5px 10px;
        font-size: 14px;
    }

    .tooltip-arrow {
        width: 0;
        height: 0;
        border-style: solid;
        position: absolute;
        margin: 5px;
        border-color: #1825D8;
    }

    &[x-placement^="top"] {
        margin-bottom: 5px;

        .tooltip-arrow {
            border-width: 5px 5px 0 5px;
            border-left-color: transparent !important;
            border-right-color: transparent !important;
            border-bottom-color: transparent !important;
            bottom: -5px;
            left: calc(50% - 5px);
            margin-top: 0;
            margin-bottom: 0;
        }
    }
}

.tooltip-views-content {
    p {
        color: #ffffff !important;
        font-weight: 400 !important;
        font-size: 16px;
        font-family: "Roboto Slab", 'HvDTrial Roboto Light', serif;
        text-transform: capitalize;
    }
}

.cursor-pointer {
    cursor: pointer;
}

.tooltip-trigger {
    position: relative;
    cursor: pointer;

    .tooltip-card {
        visibility: hidden;
        background-color: #1825D8;
        color: white;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 35%;
        transform: translateX(-60%);
        border-radius: 12px;
        opacity: 0;
        transition: opacity 0.3s;
        min-width: 200px;
        padding: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

        &:after {
            content: '';
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
            border-width: 20px 14px 0;
            border-style: solid;
            border-color: #1825D8 transparent transparent;
        }
    }

    .tooltip-stats {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        font-size: 14px;
    }

    .tooltip-views {
        font-size: 13px;
        opacity: 0.9;
    }

    .stat-item {
        display: flex;
        align-items: center;
        gap: 6px;

        .stat-text {
            color: #ffffff !important;
            font-weight: 400 !important;
            font-size: 16px;
            font-family: "Roboto Slab", 'HvDTrial Roboto Light', serif;
        }
    }

    &:hover .tooltip-card {
        visibility: visible;
        opacity: 1;
    }
}

.tooltip-trigger {
    .tooltip-card {
        .tooltip-image {
            border-radius: 12px;
            overflow: hidden;
            height: auto;
            max-height: 400px;
            background: transparent;
            aspect-ratio: 4/5;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
            }
        }

        @media (max-width: 767px) {
            .tooltip-image {
                aspect-ratio: 1/1;
                max-height: 300px;
            }
        }
    }
}
</style>

<script>

export default {
    props: ['isShowTooltip', 'isInfoDetail', 'isShowPost', 'isShowAll', 'insight', 'campaign', 'influencer', 'image', 'title'],
    
    data() {
        return {
            validStatuses: ['todo', 'inprogress', 'finished']
        }
    },

    methods: {
        countTotalReachOnChannel(channels){
            const campaignPlatformId = this.campaign.platform_id
            const detailChannel = channels.find(item => item.platform_id === campaignPlatformId)
            return detailChannel ? detailChannel.read_reach : 0
        },
        getTotalInfluencers() {
            if (!this.campaign || !this.campaign.jobs) return 0;
            return this.campaign.jobs.filter(job => this.validStatuses.includes(job.read_status)).length;
        },
        getTotalInfluencerFollowers(){
            const detailInfluencerJobOnCampaign = this.campaign.jobs.find(item => item.influencer_id === this.influencer.id)
            if(detailInfluencerJobOnCampaign){
                return this.countTotalReachOnChannel(detailInfluencerJobOnCampaign.influencer.channels)
            }
            return 0
        },
        getTotalCampaignFollowers() {
            const listJobs = this.campaign.jobs.filter(job => this.validStatuses.includes(job.read_status));
            return listJobs.reduce((total, job) => {
                const totalReach = this.countTotalReachOnChannel(job.influencer.channels)
                return total + totalReach
            }, 0)
        },
        getTotalContentMedia() {
            if (!this.campaign || !this.campaign.jobs) return 0;
            const listJobs = this.campaign.jobs.filter(job => this.validStatuses.includes(job.read_status));
            return listJobs.reduce((total, job) => {
                return total + (job.contents_media ? job.contents_media.length : 0);
            }, 0);
        },
        getInfluencerContentMedia() {
            if (!this.campaign || !this.campaign.jobs || !this.influencer) return 0;
            const detailInfluencerJobOnCampaign = this.campaign.jobs.find(item => item.influencer_id === this.influencer.id);
            if (detailInfluencerJobOnCampaign && this.validStatuses.includes(detailInfluencerJobOnCampaign.read_status)) {
                return detailInfluencerJobOnCampaign.contents_media ? detailInfluencerJobOnCampaign.contents_media.length : 0;
            }
            return 0;
        },
        formatNumber(number) {
            if (number === 0) return 0;
            return new Intl.NumberFormat('da-DK', { minimumIntegerDigits: 2 }).format(number)
        },
        formatPercentage(number) {
            if (number === 0) return '0%';
            return new Intl.NumberFormat('da-DK', { minimumIntegerDigits: 2 }).format(number) + '%';
        },
        getEngagementRateInfluencer() {
            const followers = this.getTotalInfluencerFollowers();
            if (followers === 0) return 0;
            return parseFloat(((this.insight.accounts_engaged / followers) * 100).toFixed(2));
        },
        getEngagementRatePost() {
            const followers = this.getTotalInfluencerFollowers();
            if (followers === 0) return 0;
            return parseFloat(((this.insight.accounts_engaged / followers) * 100).toFixed(2));
        },
        getEngagementRateCampaign() {
            const followers = this.getTotalCampaignFollowers();
            if (followers === 0) return 0;
            return parseFloat(((this.insight.accounts_engaged / followers) * 100).toFixed(2));
        }
    }
}
</script>
